import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-management-section',
  templateUrl: './management-section.component.html',
  styleUrls: ['./management-section.component.scss']
})
export class ManagementSectionComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
